<template>
  <li class="w-full">
    <NuxtLink
      :to="path"
      class="group grid grid-cols-[28px_1fr_auto] items-center gap-2.5 rounded-lg px-2.5 py-2 cursor-pointer transition-colors"
      :class="
        isActive
          ? 'bg-primary-500 text-white shadow-[0_1px_2px_0_rgba(79,70,229,0.25)]'
          : 'text-surface-700 hover:bg-surface-100 hover:text-surface-900'
      "
    >
      <span
        class="flex items-center justify-center text-[18px] leading-none"
        :class="
          isActive
            ? 'text-white'
            : 'text-surface-500 group-hover:text-surface-700'
        "
      >
        <font-awesome-icon
          :icon="icon"
          fixed-width
        />
      </span>
      <span class="truncate text-sm font-medium">{{ title }}</span>
      <button
        class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 shrink-1 w-6 h-6 rounded-lg flex items-center justify-center bg-primary-200"
        @click.prevent.stop="$emit('unpin')"
      >
        <AppIcon
          icon="fa-regular fa-xmark"
          size="xs"
          class="text-primary-700"
        />
      </button>
    </NuxtLink>
  </li>
</template>

<script setup lang="ts">
import { UserPinType } from '~/types/UserPin'

const route = useRoute()

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  type: {
    type: String as PropType<UserPinType>,
    required: true,
  },
  path: {
    type: String,
    required: true,
  },
  isNew: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const isActive = computed(() => {
  if (!props.path) return false
  return route.fullPath === props.path
})

defineEmits(['unpin'])

const icon = computed(() => {
  if (!props.type) return undefined

  switch (props.type) {
    case UserPinType.SIMULATION:
      return 'fa-regular fa-film'
    case UserPinType.CHARACTER:
      return 'fa-regular fa-person-dots-from-line'
    case UserPinType.ENVIRONMENT:
      return 'fa-regular fa-diagram-venn'
    case UserPinType.ASSESSMENT:
      return 'fa-regular fa-flask-vial'
    case UserPinType.TEST:
      return 'fa-regular fa-vial'
    default:
      return undefined
  }
})
</script>
